// extracted by mini-css-extract-plugin
export default {"productCarousel":"D2-z"};